/* Footer only: no network requests, newsletter interception, or navigation rewrite. */
(function () {
  'use strict';

  var mobile = window.matchMedia('(max-width: 767.98px)');
  var initialized = new WeakSet();
  var observedPurchaseBars = new WeakSet();
  var frame = null;
  var purchaseObserver = typeof window.ResizeObserver === 'function'
    ? new window.ResizeObserver(scheduleClearance)
    : null;

  function disclosures() {
    return document.querySelectorAll('.section-footer [data-section-type="footer"] [data-ab-footer-disclosure]');
  }

  function initializeDisclosures(resetForBreakpoint) {
    disclosures().forEach(function (detail) {
      if (!resetForBreakpoint && initialized.has(detail)) return;
      /* Closed native markup is the mobile/no-script default. Only initialize
         once or on an actual breakpoint change, never on every mobile resize. */
      detail.open = !mobile.matches;
      initialized.add(detail);
    });
  }

  function updateClearance() {
    frame = null;
    var clearance = 0;
    document.querySelectorAll('.ab-sticky-purchase, [data-ab-sticky-purchase], [data-ab-v9-sticky]').forEach(function (bar) {
      if (purchaseObserver && !observedPurchaseBars.has(bar)) {
        purchaseObserver.observe(bar);
        observedPurchaseBars.add(bar);
      }
      var style = window.getComputedStyle(bar);
      var rect = bar.getBoundingClientRect();
      /* Only fixed bottom bars can cover the footer at the end of the page.
         Desktop in-flow sticky bars do not introduce unnecessary blank space. */
      if (style.position === 'fixed' && style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && parseFloat(style.bottom) >= 0) {
        clearance = Math.max(clearance, Math.ceil(rect.height + Math.max(0, parseFloat(style.bottom))) + 12);
      }
    });
    document.querySelectorAll('.section-footer').forEach(function (footer) {
      /* Mutate only the footer; Shopify purchase controls are read-only here. */
      footer.style.setProperty('--ab-footer-purchase-clearance', clearance + 'px');
    });
  }

  function scheduleClearance() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateClearance);
  }

  function initialize() {
    initializeDisclosures(false);
    scheduleClearance();
  }

  function breakpointChanged() {
    initializeDisclosures(true);
    scheduleClearance();
  }

  if (mobile.addEventListener) mobile.addEventListener('change', breakpointChanged);
  else mobile.addListener(breakpointChanged);

  window.addEventListener('resize', scheduleClearance, { passive: true });
  window.addEventListener('load', scheduleClearance);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
}());
